import {useTranslation} from 'react-i18next';
import './Footer.scss';

const Footer = () => {
    const [t] = useTranslation();

    return (
        <footer>
            <nav className="footer-links">
                <a href={`${window.environment.legalUrl}legal-hints`} target="_blank" rel="noreferrer">
                    {t('footer.LEGAL_NOTICE')}
                </a>
                <span className="separator">·</span>
                <a href={`${window.environment.legalUrl}terms-of-use`} target="_blank" rel="noreferrer">
                    {t('footer.TERMS_OF_USE')}
                </a>
                <span className="separator">·</span>
                <a href={`${window.environment.legalUrl}data-privacy`} target="_blank" rel="noreferrer">
                    {t('footer.PRIVACY_POLICY')}
                </a>
                <span className="separator">·</span>
                <a href={`${window.environment.legalUrl}impressum`} target="_blank" rel="noreferrer">
                    {t('footer.IMPRINT')}
                </a>
            </nav>
        </footer>
    );
};

export default Footer;
